import React, { useEffect } from "react";
import { Box, Container, CssBaseline, Grid, Toolbar } from "@mui/material";
import { TypographyXLarge } from "../../../../components/customComponent";
import Sidebar from "../../../../components/sidebar/Sidebar";
import EquipmentList from "./EquipmentList";
import AddBreakdown from "./AddBreakdown";
import RemoveAllBreakdown from "./RemoveAllBreakdown";
import TogglePeakHour from "./TogglePeakHour";
import EquipmentSuccessPrompt from "./EquipmentSuccessPrompt";
import EquipmentErrorPrompt from "./EquipmentErrorPrompt";
import UpdateRemark from "./UpdateRemark";
import BreakdownStatus from "./BreakdownStatus";
import { getEquipmentConfig } from "../../../store/actions/bplrt/equipmentAction";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const EquipmentBreakdown = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation("bplrtEquipment");

  useEffect(() => {
    dispatch(getEquipmentConfig());
  }, [dispatch]);

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />

      <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
        <Toolbar />
        <CssBaseline />

        <Container maxWidth="xl">
          <Box sx={{ mb: 4 }}>
            <TypographyXLarge sx={{ fontWeight: 700 }}>
              {t("title")}
            </TypographyXLarge>
          </Box>

          <EquipmentSuccessPrompt />
          <EquipmentErrorPrompt />

          <BreakdownStatus />

          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              container
              item
              xs={12}
              direction="row"
              justifyContent="space-between"
            >
              <Box display={"flex"}>
                <Box sx={{ mr: 2, mt: 1 }}>
                  <TogglePeakHour />
                </Box>
              </Box>

              <Box sx={{ mt: 1 }} display={"flex"}>
                <Box sx={{ mr: 2 }}>
                  <UpdateRemark />
                </Box>

                <Box sx={{ mr: 2 }}>
                  <AddBreakdown />
                </Box>

                <Box>
                  <RemoveAllBreakdown />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <EquipmentList />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default EquipmentBreakdown;
